import React from "react";
import Wrapper from "../../hoc/Wrapper/Wrapper";
import ChequeContractList from "../../components/ChequeContract/List/ChequeContractList";
import BreadcrumbsTemp from "../../components/UI/BreadCrumb/BreadCrumbCustom";
import { withRouter } from "react-router";

const ChequeContractListPage = (props) => {
  return (
    <Wrapper>
      <BreadcrumbsTemp
        items={[
          {
            title: "لیست خرید دین ها ",
            to: props.history.location.pathname,
          },
        ]}
      />
      <ChequeContractList name={" "} />
    </Wrapper>
  );
};

export default withRouter(ChequeContractListPage);
